export enum DocumentBridgeEvents {
  View = 'doc_bridge_view',
  ClientView = 'doc_bridge_client_view',
  DownloadClick = 'doc_bridge_download_click',
  DownloadSuccess = 'doc_bridge_download_success',
  DownloadError = 'doc_bridge_download_error',
  LoadMoreError = 'doc_bridge_load_more_error',
  FilesSelected = 'doc_bridge_files_selected',
  UploadSubmit = 'doc_bridge_upload_submit',
  UploadSuccess = 'doc_bridge_upload_success',
  UploadError = 'doc_bridge_upload_error',
}
